import { FC, useState } from 'react'
import { LogIn, LogOut } from 'lucide-react'
import { useAuthStore } from '@/store/auth.store'
import { loginWithAuth0, logoutWithAuth0 } from '@/services/auth0Service'
import { cn } from '@/utils/cn'

interface LoginButtonProps {
  fullWidth?: boolean
  className?: string
}

const LoginButton: FC<LoginButtonProps> = ({ fullWidth = true, className = '' }) => {
  const [loading, setLoading] = useState(false)
  const isAuthenticated = useAuthStore((state: { isAuthenticated: boolean }) => state.isAuthenticated)

  const handleClick = async () => {
    try {
      setLoading(true)
      if (isAuthenticated) {
        await logoutWithAuth0()
      } else {
        await loginWithAuth0()
      }
    } catch (error) {
      console.error('Auth action failed:', error)
      setLoading(false)
    }
  }

  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 h-12 px-6 rounded-[var(--radius)] font-semibold text-sm transition-colors',
        'bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90',
        'disabled:pointer-events-none disabled:opacity-50',
        fullWidth && 'w-full',
        className
      )}
      onClick={handleClick}
      disabled={loading}
      type="button"
    >
      {loading ? (
        <span className="spinner spinner-sm" />
      ) : isAuthenticated ? (
        <LogOut className="w-4 h-4" />
      ) : (
        <LogIn className="w-4 h-4" />
      )}
      {isAuthenticated ? 'Logout' : 'Login'}
    </button>
  )
}

export default LoginButton
